import { useState, useEffect} from 'react';
import { Row, Col, Card } from 'react-bootstrap';

const CityAddGeneral = ({ formData}) => {

    const [urlInput, setUrlInput] = useState(formData.url || '');

    useEffect(() => {
        setUrlInput(formData.url || ''); // ✅ Ensure urlInput updates when formData changes
    }, [formData.url]);

    // ✅ normalize + validate
    const normalizeUrl = (raw) => {
        const s = (raw || "").trim();
        if (!s) return null;

        // If no scheme, default to https://
        const withScheme = /^[a-zA-Z][a-zA-Z0-9+\-.]*:/.test(s) ? s : `https://${s}`;

        try {
            const u = new URL(withScheme);
            // Only allow http/https
            if (!["http:", "https:"].includes(u.protocol)) return null;
            return u.toString();
        } catch {
            return null;
        }
    };

    const safeHref = normalizeUrl(urlInput);

    return (
        <>
            <Card className="card-premium">
                <Card.Body>
                    {/* Title */}
                    <Row className="align-items-center">
                        <Col>
                            <h3>General Info</h3>
                            <hr />
                        </Col>
                    </Row>
                    <Row className="mb-4">
                        <Col md={12}>
                            <h1>{formData.name}</h1>
                            <p>
                                {safeHref ? (
                                    <a href={safeHref} className="me-3" target="_blank" rel="noopener noreferrer">
                                        {urlInput}
                                    </a>
                                    ) : (
                                    <span>{urlInput}</span> // or nothing / inline error
                                )} 
                                Country: {formData.country.name}
                            </p>      
                        </Col>
                    </Row>
                </Card.Body>
            </Card>    
        </>
    );
};

export default CityAddGeneral;
